import React, { useState } from "react";
import Header from "../common/header";
import Footer from "../common/footer";
import { Button } from "../../components/ui/button";

const TermsConditions = () => {
  const [accepted, setAccepted] = useState(false);

  const handleAccept = () => {
    setAccepted(true);
    // You can also save acceptance to local storage or server if needed
  };

  return (
    <>
      <Header />
 <main className="flex-grow flex items-center justify-center mt-20 p-4 pt-24 md:pt-40">
        <div className="section privacy-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="terms-policy">
                  <div className="privacy-policy-container">
                    <div className="privacy-policy">
                      <h2>Terms & Conditions for Uber E Visa Website and Services</h2>
                      <p><strong>Last Updated:</strong> 29 January 2026</p>

                      <p>
                        Welcome to Uber E Visa (https://uberevisa.com/) (the “Platform”). 
                        These Terms & Conditions govern your access to and use of our website, online 
                        application system, communications, and visa-related services. By accessing 
                        or using the Platform, you agree to be legally bound by these Terms & Conditions. 
                        If you do not agree, you must not use the Platform.
                      </p>

                      <h3>1. Acceptance of Terms</h3>
                      <p>By using the Platform, you confirm that:</p>
                      <ul>
                        <li>You are at least 18 years old or have the legal capacity to enter into a binding agreement</li>
                        <li>You have read, understood, and agreed to these Terms & Conditions, our Privacy Policy, and any additional terms applicable to specific services.</li>
                      </ul>

                      <h3>2. Services Provided</h3>
                      <p>Uber E Visa provides online visa assistance and processing services, including but not limited to:</p>
                      <ul>
                        <li>UAE tourist visa application assistance</li>
                        <li>UAE visit visa and entry permit processing</li>
                        <li>Visa extension and amendment assistance (subject to eligibility)</li>
                        <li>Document collection, verification, and submission</li>
                        <li>Coordination with authorized visa sponsors, airlines, or immigration service providers</li>
                        <li>Customer support and application status updates</li>
                      </ul>
                      <p><strong>Important Notice:</strong> Uber E Visa acts strictly as a visa facilitation and processing service provider. 
                      We are not a government authority, immigration department, airline, or embassy. 
                      Final approval, rejection, processing time, and visa validity are determined solely by the relevant UAE immigration authorities.</p>

                      <h3>3. User Responsibilities</h3>
                      <ul>
                        <li>Provide accurate, complete, and up-to-date personal and travel information</li>
                        <li>Submit genuine, valid, and legally obtained documents</li>
                        <li>Ensure passport validity meets immigration requirements</li>
                        <li>Use the Platform only for lawful purposes</li>
                        <li>Comply with UAE immigration laws and regulations</li>
                      </ul>

                      <h3>4. Application Processing & Timelines</h3>
                      <ul>
                        <li>All visa applications are subject to verification and approval by UAE authorities</li>
                        <li>Processing times displayed on the Platform are estimated only and not guaranteed</li>
                        <li>Delays may occur due to government procedures, public holidays, security checks, or incomplete documentation</li>
                        <li>Uber E Visa is not responsible for delays caused by third-party authorities or incorrect user submissions</li>
                      </ul>

                      <h3>5. Fees & Payments</h3>
                      <ul>
                        <li>All prices, service fees, and government charges will be clearly disclosed before payment</li>
                        <li>Payments must be made in full before application processing begins</li>
                        <li>Accepted payment methods will be displayed during checkout</li>
                        <li>All visa fees, government fees, and service charges are NON-REFUNDABLE once the application has been submitted</li>
                      </ul>

                      <h3>6. Cancellation & Refund Policy</h3>
                      <ul>
                        <li>Visa applications cannot be cancelled once submitted to immigration authorities</li>
                        <li>Government fees and third-party charges are strictly non-refundable</li>
                        <li>Refunds (if applicable and approved in writing) will be processed within 7–14 business days</li>
                        <li>Uber E Visa reserves the right to deduct any processing or administrative charges already incurred</li>
                      </ul>

                      <h3>7. Visa Approval Disclaimer</h3>
                      <ul>
                        <li>Visa issuance is entirely at the discretion of UAE immigration authorities</li>
                        <li>Uber E Visa does not guarantee visa approval under any circumstances</li>
                        <li>Rejection reasons may not always be disclosed by authorities</li>
                        <li>Uber E Visa shall not be held liable for any losses resulting from visa refusal or delay</li>
                      </ul>

                      <h3>8. Intellectual Property Rights</h3>
                      <p>All content on the Platform, including text, logos, graphics, software, layout, and branding, 
                      is the intellectual property of Uber E Visa or its licensors and is protected under applicable intellectual property laws. 
                      You may not copy, reproduce, distribute, or exploit any content without prior written consent.</p>

                      <h3>9. Limitation of Liability</h3>
                      <ul>
                        <li>Visa rejections, cancellations, or delays</li>
                        <li>Losses caused by incorrect or incomplete information provided by users</li>
                        <li>Travel disruptions, missed flights, or accommodation losses</li>
                        <li>Indirect, incidental, or consequential damages</li>
                        <li>Temporary unavailability of the Platform due to technical issues</li>
                      </ul>

                      <h3>10. Privacy & Data Protection</h3>
                      <p>Your use of the Platform is subject to our Privacy Policy. By using the Platform, 
                      you consent to the collection, storage, and processing of your personal data for visa processing purposes in accordance with applicable data protection laws.</p>

                      <h3>11. Third-Party Services</h3>
                      <p>The Platform may include services provided by third-party partners such as immigration agents, sponsors, or payment gateways. 
                      Uber E Visa is not responsible for acts or omissions of third parties, decisions made by immigration authorities, or content/policies of external websites. Use of third-party services is at your own risk.</p>

                      <h3>12. Suspension & Termination</h3>
                      <p>Uber E Visa reserves the right to suspend or terminate access to the Platform without notice if:</p>
                      <ul>
                        <li>These Terms & Conditions are violated</li>
                        <li>Fraudulent or unlawful activity is suspected</li>
                        <li>Required by law or regulatory authorities</li>
                      </ul>

                      <h3>13. Amendments</h3>
                      <p>Uber E Visa may update these Terms & Conditions at any time. Changes will be effective immediately upon posting on the Platform. Continued use constitutes acceptance of the revised terms.</p>

                      <h3>14. Governing Law & Jurisdiction</h3>
                      <p>These Terms & Conditions shall be governed by and construed in accordance with the laws of the United Arab Emirates. Any disputes shall be subject to the exclusive jurisdiction of the courts of Dubai.</p>

                      <h3>15. Contact Information</h3>
                      <ul>
                        <li>Website: <a href="https://uberevisa.com/">https://uberevisa.com/</a></li>
                        <li>Email: <a href="mailto:info@uberevisa.com">info@uberevisa.com</a></li>
                        <li>Phone: +971 4 342 6666</li>
                      </ul>

                      <div className="action-buttons mt-4">
                        {!accepted ? (
                          <Button onClick={handleAccept}>I Accept</Button>
                        ) : (
                          <p>Thank you for accepting our Terms & Conditions.</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default TermsConditions;
